<div class="tv-auth-container">
  <div class="tv-auth-card">
    <div class="tv-auth-header">
      <h1>Sign in to your account</h1>
    </div>

    <div *ngIf="isLoading" class="loading-state">
      <i class="pi pi-spin pi-spinner"></i>
      <p>Generating authorization code...</p>
    </div>

    <div *ngIf="!isLoading && !errorMessage && !isAuthorized" class="code-display">
      <p class="instructions">To sign in, visit the URL below on your phone or computer and enter the code:</p>

      <div class="verification-url">
        <span class="url-label">Go to:</span>
        <span class="url-value">{{ verificationUri }}</span>
      </div>

      <div class="user-code">
        <span class="code-label">Enter code:</span>
        <span class="code-value">{{ userCode }}</span>
      </div>

      <div class="timer">
        <i class="pi pi-clock"></i>
        <span>Code expires in {{ formatTime(timeRemaining) }}</span>
      </div>

      <div class="polling-indicator" *ngIf="isPolling">
        <i class="pi pi-spin pi-sync"></i>
        <span>Waiting for authorization...</span>
      </div>
    </div>

    <div *ngIf="isAuthorized" class="success-state">
      <i class="pi pi-check-circle"></i>
      <h2>Authorization successful!</h2>
      <p>Redirecting to dashboard...</p>
    </div>

    <div *ngIf="errorMessage" class="error-state">
      <i class="pi pi-exclamation-triangle"></i>
      <p>{{ errorMessage }}</p>
      <button class="refresh-button" (click)="refreshCode()">
        <i class="pi pi-refresh"></i>
        Get New Code
      </button>
    </div>
  </div>
</div>
